import React from "react";
import "./EditorLeftMenuUpscaleControls.css";
import AiUpscaleControlMenu from "./AiUpscaleControlMenu";

const EditorLeftMenuUpscaleControls = ({
  onApplyUpscale,
  busy = false,
  error = null,
}) => {
  return (
    <div className="ai-upscale-controls-container">
      <h1>AI Upscale</h1>
      {error ? (
        <p className="ai-upscale-controls-error">{error}</p>
      ) : null}
      <AiUpscaleControlMenu onApply={onApplyUpscale} busy={busy} />
    </div>
  );
};

export default EditorLeftMenuUpscaleControls;
